import React, { useState } from "react";
import { AlertTriangle, ChevronDown, Loader2, Wrench, X } from "lucide-react";
import { Switch } from "../ui/switch";

const STATUS = {
  pending: "Fixing automatically in a moment…",
  fixing: "Auto-fix is working on it…",
  gaveup: "Auto-fix tried twice — describe the problem in chat or try again.",
};

export const ErrorBanner = ({ errors, status, autoFix, onToggleAutoFix, onFixNow, onDismiss, cost }) => {
  const [open, setOpen] = useState(false);
  if (!errors.length) return null;
  const working = status === "pending" || status === "fixing";
  return (
    <div className="border-b border-rose-200 bg-rose-50 text-xs text-rose-800" data-testid="preview-error-banner">
      <div className="flex flex-wrap items-center gap-3 px-4 py-2">
        <AlertTriangle size={14} className="text-rose-600 shrink-0" />
        <button onClick={() => setOpen(!open)} className="flex items-center gap-1 font-medium hover:text-slate-900" data-testid="preview-error-toggle">
          {errors.length} error{errors.length > 1 ? "s" : ""} in your app <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
        {STATUS[status] && <span className="flex items-center gap-1.5 text-rose-700" data-testid="preview-autofix-status">{working && <Loader2 size={11} className="animate-spin" />}{STATUS[status]}</span>}
        <div className="ml-auto flex items-center gap-3">
          <label className="flex items-center gap-2 text-rose-700 cursor-pointer">
            <Switch checked={autoFix} onCheckedChange={onToggleAutoFix} data-testid="preview-autofix-switch" className="scale-75 data-[state=checked]:bg-emerald-500" /> Auto-fix
          </label>
          {!working && (
            <button onClick={onFixNow} data-testid="preview-fix-now-btn" className="h-7 px-2.5 rounded-md bg-rose-500 text-white font-semibold flex items-center gap-1.5 hover:bg-rose-400">
              <Wrench size={12} /> Fix now{cost != null && <span className="font-mono opacity-80">· {cost}cr</span>}
            </button>
          )}
          <button onClick={onDismiss} aria-label="Dismiss errors" data-testid="preview-error-dismiss" className="text-rose-600 hover:text-slate-900"><X size={14} /></button>
        </div>
      </div>
      {open && (
        <ul className="px-4 pb-3 space-y-1 font-mono text-[11px] text-rose-700 max-h-40 overflow-y-auto thin-scroll" data-testid="preview-error-list">
          {errors.map((e, i) => <li key={i} className="break-words">[{e.kind}] {e.message}{e.source ? ` — ${e.source}${e.line ? `:${e.line}` : ""}` : ""}</li>)}
        </ul>
      )}
    </div>
  );
};

export default ErrorBanner;
